import { Button, Divider, Flex, Tag, Tooltip, Typography } from "antd";
import CustomIcon from "../../layouts/CustomIcon";
import { Link } from "react-router-dom";
import { useAuthContext } from "../../user/AuthProvider";
import { PATHS } from "../../../utills/paths";
import { PRODUCTS, TEST_TYPE_TASK } from "../../../actions/constants";
import { roundCredits } from "../../../utills/common";

const { Text } = Typography;

export default function PooledCreditUsageTooltip({ open = false, setOpen = () => {}, onOpenCreditsHelp = () => {}, children = null }) {
  const { products, creditUsage, organization, subscription, planInfo, userAccess, totalCreditsUsed } = useAuthContext();
  const { isOrgAdminOrOwner = false } = userAccess || {};
  const { credits_response_total, credits_response_permanent } = organization || {};
  const { own_users } = subscription?.plan || {};
  const { isCustomPlan, isTrialPlan, balances } = planInfo || {};
  const { credits: { used: { stripeMeter } = {} } = {} } = balances || {};

  return (
    <Tooltip
      open={open}
      onOpenChange={setOpen}
      trigger='click'
      placement='bottom'
      styles={{ container: { width: "250px", padding: "10px 20px" } }}
      title={
        <Flex vertical gap={10}>
          <Flex align='center' justify='space-between'>
            <Text className='text-white font-size-12px fw-600'>Pooled Credit Usage</Text>
            <Button
              size='small'
              type='text'
              className='text-white'
              icon={<CustomIcon name='close' width={16} height={16} />}
              onClick={() => setOpen(false)}
            />
          </Flex>

          <Flex align='center' justify='space-between'>
            <Text className='font-size-12px color-A9A9BC'>Research Method</Text>
            <Text className='font-size-12px color-A9A9BC'>Credits</Text>
          </Flex>

          {products?.map(({ key, name, color, type, isNoRecording }) => {
            const productType = type === TEST_TYPE_TASK && isNoRecording ? PRODUCTS.NORECORDING : type;
            return (
              <Flex align='center' justify='space-between' key={key}>
                <Flex align='center' gap={5} className='w-75'>
                  <Tag className='border-radius-circle w-10px h-10px p-0' style={{ backgroundColor: color, borderColor: color }}></Tag>
                  <Text className='text-white font-size-12px w-90'>{name}</Text>
                </Flex>
                <Text className='text-white font-size-12px'>{roundCredits(creditUsage?.usage?.usedCredit?.[productType])}</Text>
              </Flex>
            );
          })}

          <Divider className='m-0 border-E3E8EF' />

          <Flex align='center' justify='space-between'>
            <Text className='text-white font-size-12px fw-600'>Total Credits Used</Text>
            <Text className='text-white font-size-12px'>{totalCreditsUsed}</Text>
          </Flex>

          {!isCustomPlan && !isTrialPlan && (
            <Flex align='center' justify='space-between'>
              <Flex vertical>
                <Text className='text-white font-size-12px fw-600'>Allocated Monthly Credits</Text>
                <Text className='text-white font-size-12px'>(Resets in 30 days)</Text>
              </Flex>
              <Text className='text-white font-size-12px'>{own_users}</Text>
            </Flex>
          )}

          {!isCustomPlan && !isTrialPlan && Number(credits_response_permanent) > 0 && (
            <Flex align='center' justify='space-between'>
              <Flex vertical>
                <Text className='text-white font-size-12px fw-600'>Carryover Credits</Text>
              </Flex>
              <Text className='text-white font-size-12px'>{roundCredits(credits_response_permanent)}</Text>
            </Flex>
          )}

          <Divider className='m-0 border-E3E8EF' />

          <Flex align='center' justify='space-between'>
            <Text className='text-white font-size-12px fw-600'>Total Credits Remaining</Text>
            <Text className='text-white font-size-12px'>{roundCredits(credits_response_total)}</Text>
          </Flex>

          {Number(stripeMeter) > 0 && (
            <Flex align='center' justify='space-between'>
              <Text className='text-white font-size-12px fw-600'>Overages this month</Text>
              <Text className='text-white font-size-12px'>{roundCredits(stripeMeter)}</Text>
            </Flex>
          )}

          <Flex align='center' justify='space-between'>
            {isOrgAdminOrOwner ? (
              <Link className='text-underline text-white font-size-14px' to={PATHS.V2.CREDITSUSAGE}>
                See details
              </Link>
            ) : (
              <span />
            )}

            <Button
              type='text'
              className='text-underline text-white font-size-14px p-0'
              onClick={() => {
                setOpen(false);
                onOpenCreditsHelp();
              }}
            >
              How credits work
            </Button>
          </Flex>
        </Flex>
      }
    >
      {children}
    </Tooltip>
  );
}
